module.exports = __webpack_public_path__ + "img/newborn.509ae318.jpg";